var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrebookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.251.004c.362-.04.688.219.733.58.046.36-.206.69-.566.743-.062.005-6.184.775-7.288.993-.796.156-.796.47-.796.679 0 .356.28.65.635.666l8.622-.995c.19-.022.379.038.521.165.142.126.223.307.223.497v11c0 .336-.25.62-.584.662 0 0-8.016 1.005-8.083 1.005-.714.02-1.404-.253-1.909-.758-.505-.505-.779-1.195-.758-1.909V3c0-.605.243-1.667 1.871-1.988C3.022.785 9.002.036 9.252.004zm-.254 3.995l-3 .29c-.092.01-.166.087-.166.173v4.729c0 .063.04.116.102.134.062.019.134-.001.181-.05L7.38 7.96c.066-.067.17-.077.236-.023l1.265 1.07c.048.04.12.045.181.015.062-.03.103-.09.103-.154V4.14c0-.086-.075-.15-.167-.14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrebookings);
export default __webpack_public_path__ + "static/media/prebookings.a928a7e01ff61296807c5e0f24c1b1d2.svg";
export { ForwardRef as ReactComponent };